<div class="text" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic">
    <i *ngIf="isCollapsed" class="fa fa-angle-right"></i>
    <i *ngIf="!isCollapsed" class="fa fa-angle-down"></i> {{item.name}}
</div>
<div class="text ml-3" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">{{item.main.time}}</div>